import { useEffect } from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./screens/Home";
import { destroyLenis, initLenis } from "./utils/lenisScroll";
import { Analytics } from "@vercel/analytics/react";

function App() {

  useEffect(() => {
    initLenis()
    
    return () => {
      destroyLenis()
    }
  },[])

  return (
    <div className="app w-full">
      <Analytics/>
      <Header />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
